import React, { FC } from 'react';
import DataInfo from '@components/data_info';
import Input from '@components/common/input';
import styles from './styles.module.scss';
import { TConsumer } from '@xeppt/xeppt-sdk/types';

interface IProps {
    consumer?: TConsumer;
}

const GeneralSection: FC<IProps> = ({ consumer }) => {
    return (
        <div className={styles.wrapper}>
            {consumer?.bank_details && (
                <DataInfo label="Bank information">
                    <div className={styles.row}>
                        <Input
                            readOnly
                            full
                            label="Customer number"
                            value={consumer?.bank_details?.customer_number || ''}
                        />
                        <Input
                            readOnly
                            full
                            label="Wallet ID"
                            value={consumer?.bank_details?.wallet_id.toString() || ''}
                        />
                    </div>
                </DataInfo>
            )}
            {consumer?.wallets && (
                <DataInfo label="Wallets">
                    {consumer?.wallets?.map((item) => {
                        return (
                            <div className={styles.row} key={item.currency}>
                                <Input
                                    readOnly
                                    full
                                    label="Balance"
                                    value={item.balance.toFixed(2)}
                                />
                                <Input readOnly full label="Currency" value={item.currency} />
                            </div>
                        );
                    })}
                </DataInfo>
            )}
        </div>
    );
};

export default GeneralSection;
